import { render } from "./BasicSnackbar.vue?vue&type=template&id=db40975a"
import script from "./BasicSnackbar.vue?vue&type=script&lang=js"
export * from "./BasicSnackbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__